export const lsu_valid_email_extensions = [
    'lsu.edu',
    'agcenter.lsu.edu',
    'lsuagcenter.com',
    'listserv.lsu.edu',
    'lists.lsu.edu',
    'online.lsu.edu',
    'grok.lsu.edu',
    'iam.lsu.edu',
    'mylsu.lsu.edu',
    'lsua.edu',
    'lsue.edu',
    'lsus.edu',
    'lsuhsc.edu',
    'lsuhs.edu',
    'lsuhospitals.org',
    'lsuhealth.org',
    'lsuhealthfoundation.org',
    'pbrc.edu',
    'webmaster.lsu.edu',
    'postmaster.lsuhsc.edu',
    'helpdesk.lsuhsc.edu',
    // Add more emails extensions here
];